import { ChangeEvent, useState } from 'react';
import { Box, Button } from '@mui/material';
import { Icon, Checkbox } from '@pwc/pwc-deals-ui';
import { Dialog } from './Dialog';

export const HIDE_LOST_COMMENTS_DIALOG_SESSION_STORAGE =
  'hide-lost-comments-dialog';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const LostCommentsWarningDialog = ({
  open,
  onConfirm,
  onClose,
}: Props) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const title = (
    <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
      <Icon name="alert" className="icon-yellow fill" width="24" />
      <Box
        sx={{
          width: '85%',
          marginLeft: '0.8rem',
          marginTop: '-0.4rem',
          fontSize: '22px',
        }}
      >
        Content and associated comments may get deleted
      </Box>
    </Box>
  );

  const content = (
    <>
      <Box
        mb="1rem"
        sx={{
          fontSize: '16px',
        }}
      >
        If you change layouts or edit or delete content, existing content and
        all associated comments may be deleted. To keep your existing content
        and comments:
      </Box>

      <Box>
        <ul>
          <li>
            <Box mt="1rem">
              Add a section to the page and copy content and comments from the
              previous layout to the new one
            </Box>
          </li>
          <li>
            <Box mt="1rem">
              For comments, you can also create a new comment on any part of the
              page that will not be deleted and copy the existing comments into
              the new comment
            </Box>
          </li>
          <li>
            <Box mt="1rem">
              Copy multiple comments into one comment, if easier
            </Box>
          </li>
        </ul>
      </Box>
      <Box ml="1rem">
        <Checkbox
          dataTestId="lost-comments-dialog-test"
          id="lost-comments-dialog-selector"
          label={`Don't show again`}
          onChange={handleChange}
          selected={checked}
          indeterminate={false}
        />
      </Box>
    </>
  );
  const actions = (
    <>
      <Button variant="text" size="large" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="large"
        onClick={() => {
          if (checked) {
            window.sessionStorage.setItem(
              HIDE_LOST_COMMENTS_DIALOG_SESSION_STORAGE,
              'true'
            );
          }
          onConfirm();
        }}
      >
        Continue
      </Button>
    </>
  );

  return (
    <Dialog
      content={content}
      title={title}
      open={open}
      actions={actions}
      onClose={onClose}
    />
  );
};
